import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import './Navbar.css';

const Navbar = () => {
  const [isScrolled, setIsScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <motion.nav
      initial={{ y: -100 }}
      animate={{ y: 0 }}
      transition={{ duration: 0.6, ease: "easeOut" }}
      className={`navbar ${isScrolled ? 'scrolled' : ''}`}
    >
      <div className="navbar-container">
        <Link to="/" className="navbar-logo">
          <img 
            src="https://storage.googleapis.com/download/storage/v1/b/ct-bucket-prod/o/1757842672771creedom_logo.png?generation=1757842664977583&alt=media" 
            alt="Creedom Logo" 
            className="logo-image"
          />
        </Link>
      </div>
    </motion.nav>
  );
};

export default Navbar;
